import { useMemo, useRef } from "react";
import { Points, PointMaterial } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
// import * as THREE from "three";

const BackgroundParticles = () => {
    const particlesRef = useRef();

    const particles = useMemo(() => {
        const COUNT = window.innerWidth < 768 ? 350 : 1200;
        const positions = new Float32Array(COUNT * 3);

        for (let i = 0; i < 1200; i++) {
            const radius = 8 + Math.random() * 8;
            const angle = Math.random() * Math.PI * 2;
            positions[i * 3] = Math.cos(angle) * radius;
            positions[i * 3 + 1] = (Math.random() - 0.5) * 8;
            positions[i * 3 + 2] = (Math.random() - 0.5) * 10;
        }

        return positions;
    }, []);

    useFrame(( state ) => {
        const t = state.clock.elapsedTime;
        if (particlesRef.current) {
            particlesRef.current.rotation.y = t * 0.015;
            particlesRef.current.rotation.x = Math.sin(t * 0.2) * 0.02;
        }
    });

    return (
        <Points ref={particlesRef} positions={particles} stride={3}>
            <PointMaterial
                transparent
                color="#60a5fa"
                size={0.025}
                sizeAttenuation
                depthWrite={false}
                opacity={0.7}
            />
        </Points>
    );
};

export default BackgroundParticles;
